































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required, maxLength, helpers } from 'vuelidate/lib/validators';
import RegexValidators from '@/shared/regex-validators';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';

const addressCheck = helpers.regex('addressCheck', new RegExp(RegexValidators.address));
const postalCode = helpers.regex('postalCode', new RegExp(RegexValidators.postalCode));
const phone = helpers.regex('phone', new RegExp(RegexValidators.phoneNo));

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
  validations: {
    address: {
      fullName: { required, maxLength: maxLength(50) },
      address1: { required, addressCheck, maxLength: maxLength(50) },
      address2: { required, maxLength: maxLength(50) },
      city: { required, addressCheck, maxLength: maxLength(50) },
      country: { required },
      state: { required },
      province: { required },
      postal: { required, postalCode, maxLength: maxLength(50) },
      phone: { required, phone },
    },
  },
})
export default class PhysicalAddress extends SwExtendedVue {
  @Prop()
  showPhysicalAddressDialog: boolean;
  submitted: boolean = false;
  errorMessage: string = '';
  address: {
    fullName: string,
    address1: string,
    address2: string;
    city: string;
    country: string;
    state: string;
    postal: string;
    phone: string;
    province: string;
  } = {
    fullName: '',
    address1: '',
    address2: '',
    city: '',
    country: '',
    state: '',
    postal: '',
    phone: '',
    province: '',
  };
  addressType: string = 'savedAddress';
  savedAddress: any = {};
  countryOptions: any = [];
  stateOptions: any = [];
  mounted() {
    this.getPhysicalAddress();
    this.getCountriesFromServer();
  }
  closeDialog() {
    this.$emit('closeDialog');
  }
  validateForm() {
    this.submitted = true;
    this.errorMessage = '';
    if (this.address.country === 'US' || this.address.country === 'CA') {
      this.address.province = this.address.state;
    } else {
      this.address.state = this.address.province;
    }
    this.$v.$touch();
    if (this.$v.$invalid) {
    } else {
      const request = {
        // "customerTaskId: this.data.customerTaskId,
        fullName: this.address.fullName,
        address: this.address.address1,
        address1: this.address.address2,
        city: this.address.city,
        country: this.address.country,
        state: this.address.state,
        province: this.address.province,
        zipcode: this.address.postal,
        phone: this.address.phone,
        // "taskName: this.data.taskName
      };
      this.$emit('closeDialog', request);
    }
  }
  getPhysicalAddress() {
    this.$store
      .dispatch('MswProductsStoreModule/getPhysicalAddress')
      .then((res: any) => {
        this.$store.commit('stopLoading');
        this.savedAddress = res.content;
        this.address.fullName = res.content.FULLNAME;
        this.address.address1 = res.content.ADDRESSLINE1;
        this.address.address2 = res.content.ADDRESSLINE2;
        this.address.city = res.content.CITY;
        this.address.country = res.content.COUNTRY;
        this.address.phone = res.content.PHONENUMBER;
        this.address.state = res.content.STATE;
        this.address.postal = res.content.ZIPCODE;
        this.address.province = res.content.PROVINCE;
      });
  }
  getCountriesFromServer() {
    this.$store
      .dispatch('MswProductsStoreModule/getCountries')
      .then((res: any) => {
        this.$store.commit('stopLoading');
        this.countryOptions = res.content.lstCountries.map((each: any) => {
          return {
            id: each.countryCode,
            label: each.countryName,
            value: each.countryCode,
          };
        });
      });
  }
  setCountry(country: string) {
    this.address.country = country;
    if (this.address.country === 'US' || this.address.country === 'CA') {
      this.getStates(country);
      this.address.province = '';
      this.address.state = '';
    }
  }
  getStates(countryCode: string) {
    this.$store
      .dispatch('MswProductsStoreModule/getStates', { countryCode })
      .then((res: any) => {
        this.$store.commit('stopLoading');
        this.stateOptions = res.map((each: any) => {
          return {
            id: each.stateCode,
            label: this.$t(each.stateName),
            value: each.stateCode,
          };
        });
      });
  }
}
